import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';

const state = {
    numeroPuntoVenta: 0,
    pjeGastosFijos: 0,
    pjeInversionFutura: 0,
    pjeImpuestosInternos: 0,
    pjeIva: 0,
    pjeMargenOrdenTrabajo: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_PARAMETROS' (state) {
        state.numeroPuntoVenta = 0;
        state.pjeGastosFijos = 0;
        state.pjeInversionFutura = 0;
        state.pjeImpuestosInternos = 0;
        state.pjeIva = 0;
        state.pjeMargenOrdenTrabajo = 0;
    },
    'SET_PARAMETROS'(state, parametros) {
        state.numeroPuntoVenta = parametros.numeroPuntoVenta;
        state.pjeGastosFijos = parametros.pjeGastosFijos;
        state.pjeInversionFutura = parametros.pjeInversionFutura;
        state.pjeImpuestosInternos = parametros.pjeImpuestosInternos;
        state.pjeIva = parametros.pjeIva;
        state.pjeMargenOrdenTrabajo = parametros.pjeMargenOrdenTrabajo;
    },
};

const getters = {
    getField,

    totalDocumentos(state) {
        return parseFloat(state.pesos) 
            + parseFloat(state.chequesPropios)
            + parseFloat(state.transferenciasProveedores)
            + parseFloat(state.tarjetasCupones);
    },
    saldo(state) {
        return parseFloat(state.totalSeleccionado) - parseFloat(this.totalDocumentos);
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARAMETROS');

            apiAxios.get('parametros') 
                .then(res => {
                    commit('SET_PARAMETROS', res.data);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let parametros = {
                numeroPuntoVenta: parseInt(state.numeroPuntoVenta),
                pjeGastosFijos: parseFloat(state.pjeGastosFijos),
                pjeInversionFutura: parseFloat(state.pjeInversionFutura),
                pjeImpuestosInternos: parseFloat(state.pjeImpuestosInternos),
                pjeIva: parseFloat(state.pjeIva),
                pjeMargenOrdenTrabajo: parseFloat(state.pjeMargenOrdenTrabajo),
            }

            let url = 'parametros';

            apiAxios.post(url, parametros)
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    let res = {
                        updated: false,
                        errorMessage: errorMessage
                    }    
                    reject(res)
                })
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}